/**
 * Static data for the AvA Library — extracted from AvALibrary.js as part of
 * the Wave 2 component split. Pure data, zero behaviour.
 *
 * - AVA_IMAGES        20 unique photorealistic AvA portrait URLs
 * - PRESET_AVAS       18 preset AvA options keyed by category
 * - CATEGORIES        the 4 top-level filter chips
 * - ALL_PERSONALITY_OPTIONS  the 5 personality archetypes
 * - PERSONALITY_BY_TAB       which archetypes show on each category tab
 * - LANGUAGES         the 6 supported language values
 * - VOICES            the 9 OpenAI TTS voices with age + description
 * - WEALTH_STATES     6-state rotation used by the Wealth-tab pagination
 */
import { Heart, Users, Briefcase, Sparkles } from 'lucide-react';

// State rotation for Wealth category by page number
export const WEALTH_STATES = ['California', 'Texas', 'Florida', 'New York', 'Nevada', 'Delaware'];

// Photorealistic AvA images — 20 unique photos (ZERO duplicates)
export const AVA_IMAGES = {
  // Female AvAs - Original
  luna: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/84tos0ea_Californina%20businesswoman%20age%2047s%20with%20hazel%20green%20eyes%2C%20long%20chestnut%20hair.jpg',
  emma: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/sinhnlzj_Californina%20businesswoman%20age%2048%27s%20with%20hazel%20blue%20eyes%2C%20long%20black%20hair.jpg',
  sarah: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/yjpr9hrp_Californina%20businesswoman%20age%2048%27s%20with%20hazel%20green%20eyes%2C%20long%20chestnut%20hair.jpg',
  maya: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/7qelqbu3_Californina%20businesswoman%20age%2046s%20with%20hazel%20green%20eyes%2C%20long%20chestnut%20hair.jpg',
  aria: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/es5urd6w_Californina%20businesswoman%20age%2047%20with%20hazel%20blue%20eyes%2C%20black%20blond%20hair.jpg',
  chloe: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/cxklmnoz_Hispanicn%20woman%20age%2023%27s%20%20brown%20hair%20hazel%20green%20eyes.jpg',
  victoria: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/wjpvihav_woman%20age%2055%20%20brown%20or%20blond%20or%20gray%20hair%20hazel%20green%20or%20blue%20and%20hazel%20eyes.jpg',
  grace: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/vzv8c0l8_woman%20age%2055%27s%20%20brown%20or%20blond%20or%20gray%20hair%20hazel%20green%20or%20blue%20and%20hazel%20eyes.jpg',
  // Female AvAs - NEW (5 more unique)
  valentina: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/7bf70exr_Hispanicn%20woman%20age%2025%27s%20%20brown%20hair%20hazel%20green%20eyes.jpg',
  camila: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/h5uxf5sg_Hispanicn%20woman%20age%2026%20%20brown%20hair%20hazel%20green%20eyes.jpg',
  isabella: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/p2n0fxv3_Californina%20businesswoman%20hispanic%20age%2028%27s%20with%20light%20blue%20eyes%2C%20black%20hair%2C.jpg',
  priya: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/2tktukxh_Woman%20age%2022%27s%20%20US%20african%20american%20brown%20hair.jpg',
  natalie: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/cp4dvzxh_woman%20age%2025%20blond%20or%20gray%20hair%20hazel%20green%20or%20blue%20and%20hazel%20eyes.jpg',
  // Male AvAs
  alex: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/vzpnau91_Californina%20Man%20age%2030%27s%20black%20brown%20hair%2C%20hazel%20blue%20eyes%2C%20glasses.jpg',
  jordan: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/fmpudbq4_Hispanicn%20Male%20age%2020%27s%20brown%20hair%20hazel%20green%20eyes.jpg',
  marcus: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/0znltj6a_Californina%20Man%20age%2030%27s%20black%20gray%20hair%2C%20hazel%20blue%20eyes.jpg',
  david: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/qswariu0_Hispanicn%20Male%20age%2024%20%20brown%20hair%20hazel%20green%20eyes.jpg',
  james: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/a0c3gzww_Californina%20man%20age%2055%20black%20gray%20hair%2C%20hazel%20blue%20eyes%2C%20glasses.jpg',
  sam: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/opb4xm7c_Californina%20man%20age%2055%27s%20black%20gray%20hair%2C%20hazel%20blue%20eyes%2C.jpg',
  morgan: 'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/artifacts/8zlh4kmx_Californina%20man%20age%2056%20black%20gray%20hair%2C%20hazel%20blue%20eyes%2C%20glasses.jpg',
};

// Preset AvA options with categories — 18 presets, ALL UNIQUE images (zero duplicates)
export const PRESET_AVAS = {
  health: [
    { id: 'health_1', name: 'Luna', image: AVA_IMAGES.luna, personality: 'Reflective' },
    { id: 'health_2', name: 'Emma', image: AVA_IMAGES.emma, personality: 'Steady' },
    { id: 'health_3', name: 'Sarah', image: AVA_IMAGES.sarah, personality: 'Reflective' },
    { id: 'health_4', name: 'Maya', image: AVA_IMAGES.maya, personality: 'Steady' },
    { id: 'health_5', name: 'Aria', image: AVA_IMAGES.aria, personality: 'Encouraging' },
    { id: 'health_6', name: 'Chloe', image: AVA_IMAGES.chloe, personality: 'Reflective' },
  ],
  wealth: [
    { id: 'wealth_1', name: 'Alex', image: AVA_IMAGES.alex, personality: 'Challenging' },
    { id: 'wealth_2', name: 'Jordan', image: AVA_IMAGES.jordan, personality: 'Encouraging' },
    { id: 'wealth_3', name: 'Sam', image: AVA_IMAGES.sam, personality: 'Challenging' },
    { id: 'wealth_4', name: 'Riley', image: AVA_IMAGES.valentina, personality: 'Energising' },
    { id: 'wealth_5', name: 'Casey', image: AVA_IMAGES.camila, personality: 'Challenging' },
    { id: 'wealth_6', name: 'Morgan', image: AVA_IMAGES.morgan, personality: 'Encouraging' },
  ],
  happiness: [
    { id: 'happiness_1', name: 'Marcus', image: AVA_IMAGES.marcus, personality: 'Energising' },
    { id: 'happiness_2', name: 'Victoria', image: AVA_IMAGES.victoria, personality: 'Reflective' },
    { id: 'happiness_3', name: 'Isabella', image: AVA_IMAGES.isabella, personality: 'Energising' },
    { id: 'happiness_4', name: 'Grace', image: AVA_IMAGES.grace, personality: 'Steady' },
    { id: 'happiness_5', name: 'Priya', image: AVA_IMAGES.priya, personality: 'Energising' },
    { id: 'happiness_6', name: 'Natalie', image: AVA_IMAGES.natalie, personality: 'Reflective' },
  ],
};

export const CATEGORIES = [
  { id: 'all', label: 'All AvAs', icon: Sparkles, color: 'bg-purple-500' },
  { id: 'health', label: 'Ava Health', icon: Heart, color: 'bg-pink-500' },
  { id: 'wealth', label: 'Ava Wealth', icon: Briefcase, color: 'bg-blue-500' },
  { id: 'happiness', label: 'Ava Happiness', icon: Users, color: 'bg-amber-500' },
];

export const ALL_PERSONALITY_OPTIONS = [
  { value: 'Reflective', label: 'Reflective', desc: 'Thoughtful and empathetic' },
  { value: 'Encouraging', label: 'Encouraging', desc: 'Motivating and uplifting' },
  { value: 'Challenging', label: 'Challenging', desc: 'Pushes you to grow' },
  { value: 'Steady', label: 'Steady', desc: 'Calm and dependable' },
  { value: 'Energising', label: 'Energising', desc: 'High-energy and fun' },
];

// Dynamic filtering: show relevant personalities per tab (4 per tab — 2×2 grid)
export const PERSONALITY_BY_TAB = {
  all: null, // show all
  health: ['Reflective', 'Steady', 'Encouraging', 'Energising'],
  wealth: ['Challenging', 'Encouraging', 'Energising', 'Steady'],
  happiness: ['Energising', 'Reflective', 'Steady', 'Encouraging'],
};

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'tl', label: 'Filipino' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'ar', label: 'Arabic' },
  { value: 'zh', label: 'Chinese' },
  { value: 'ja', label: 'Japanese' },
];

// Voice options — Sprint 207P MVP-c + Feb 2026 teen-pitch overhaul:
// 20 anonymous teen voice SLOTS, 10 female + 10 male. Each slot maps
// back to one of OpenAI's brighter TTS voices, pitched up client-side
// via `audio.playbackRate` so the same adult OpenAI engine sounds
// distinctly teen-aged (not just adult-with-a-cold).
//
// Pitch values are deliberately ≥ 1.22 — anything lower lets the
// underlying adult timbre dominate. Deep voices (onyx/fable/sage)
// are intentionally excluded from teen slots because no amount of
// pitch-shift turns them youthful.
//
// Labels in the picker are strictly anonymous: "Female Voice 1" …
// "Male Voice 10". `name` / `description` fields are intentionally
// removed — the picker renders gender + slot index only.
export const TEEN_VOICES = [
  // ── 13 Female slots (bright bases only) ────────────────────────────
  { id: 'tf1',  gender: 'Female', baseVoice: 'nova',    pitch: 1.28, speed: 1.0 },
  { id: 'tf2',  gender: 'Female', baseVoice: 'shimmer', pitch: 1.32, speed: 1.0 },
  { id: 'tf3',  gender: 'Female', baseVoice: 'nova',    pitch: 1.25, speed: 1.0 },
  { id: 'tf4',  gender: 'Female', baseVoice: 'shimmer', pitch: 1.30, speed: 1.0 },
  { id: 'tf5',  gender: 'Female', baseVoice: 'coral',   pitch: 1.28, speed: 1.0 },
  { id: 'tf6',  gender: 'Female', baseVoice: 'nova',    pitch: 1.35, speed: 1.0 },
  { id: 'tf7',  gender: 'Female', baseVoice: 'coral',   pitch: 1.25, speed: 1.0 },
  { id: 'tf8',  gender: 'Female', baseVoice: 'shimmer', pitch: 1.28, speed: 1.0 },
  { id: 'tf9',  gender: 'Female', baseVoice: 'alloy',   pitch: 1.30, speed: 1.0 },
  { id: 'tf10', gender: 'Female', baseVoice: 'nova',    pitch: 1.22, speed: 1.0 },
  { id: 'tf11', gender: 'Female', baseVoice: 'shimmer', pitch: 1.24, speed: 0.96 },
  { id: 'tf12', gender: 'Female', baseVoice: 'coral',   pitch: 1.32, speed: 1.04 },
  { id: 'tf13', gender: 'Female', baseVoice: 'alloy',   pitch: 1.26, speed: 0.94 },
  // ── 13 Male slots (light bases only — no onyx/fable/sage) ──────────
  { id: 'tm1',  gender: 'Male',   baseVoice: 'echo',    pitch: 1.25, speed: 1.0 },
  { id: 'tm2',  gender: 'Male',   baseVoice: 'alloy',   pitch: 1.30, speed: 1.0 },
  { id: 'tm3',  gender: 'Male',   baseVoice: 'echo',    pitch: 1.28, speed: 1.0 },
  { id: 'tm4',  gender: 'Male',   baseVoice: 'ash',     pitch: 1.25, speed: 1.0 },
  { id: 'tm5',  gender: 'Male',   baseVoice: 'alloy',   pitch: 1.28, speed: 1.0 },
  { id: 'tm6',  gender: 'Male',   baseVoice: 'echo',    pitch: 1.32, speed: 1.0 },
  { id: 'tm7',  gender: 'Male',   baseVoice: 'ash',     pitch: 1.22, speed: 1.0 },
  { id: 'tm8',  gender: 'Male',   baseVoice: 'alloy',   pitch: 1.25, speed: 1.0 },
  { id: 'tm9',  gender: 'Male',   baseVoice: 'echo',    pitch: 1.30, speed: 1.0 },
  { id: 'tm10', gender: 'Male',   baseVoice: 'ash',     pitch: 1.28, speed: 1.0 },
  { id: 'tm11', gender: 'Male',   baseVoice: 'echo',    pitch: 1.20, speed: 0.96 },
  { id: 'tm12', gender: 'Male',   baseVoice: 'ash',     pitch: 1.32, speed: 1.04 },
  { id: 'tm13', gender: 'Male',   baseVoice: 'alloy',   pitch: 1.22, speed: 0.94 },
];

// Sprint 207P — assign a stable anonymous "Female age X" / "Male age X"
// label to each preset card. Ages are drawn from a deterministic hash
// of the preset id so the label is stable across renders & refresh.
// Gender is inferred from the avatar id (alex/jordan/marcus/… = male).
const _MALE_KEYS = new Set([
  'alex','jordan','marcus','david','james','sam','morgan',
]);
function _hashStr(s) {
  let h = 0;
  for (let i = 0; i < (s || '').length; i++) {
    h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}
export function presetGender(preset) {
  if (!preset) return 'Female';
  const imageKey = Object.keys(AVA_IMAGES).find(k => AVA_IMAGES[k] === preset.image);
  if (imageKey && _MALE_KEYS.has(imageKey)) return 'Male';
  // wealth-tab male presets named Alex/Sam/Morgan etc.
  if ((preset.name || '').match(/^(alex|sam|morgan|james|david|jordan|marcus|peter)$/i)) return 'Male';
  return 'Female';
}
export function presetTeenAge(preset) {
  // Stable in [13,17] from the preset id (no Math.random per render).
  const seed = _hashStr((preset?.id || preset?.name || '') + '_age');
  return 13 + (seed % 5);
}
export function presetDemographicLabel(preset) {
  return `${presetGender(preset)} age ${presetTeenAge(preset)}`;
}

// Voice options (LEGACY — kept exported for any callers still importing
// the old VOICES symbol; AvALibrary now uses TEEN_VOICES). Will be
// removed once Sprint 207P regression sweep completes.
export const VOICES = TEEN_VOICES;
